module.exports = __webpack_public_path__ + "static/media/Montserrat-BlackItalic.d9b6ba59.ttf";